import clsx from 'clsx'
import { IBadgeProps } from './types'
import styles from './styles.module.scss'

const Badge = ({
  text,
  color = 'red',
  id,
  size = 'md',
  style,
  className,
  ...props
}: IBadgeProps) => {
  return (
    <div
      className={clsx('mui-badge', styles.badge, styles[color], styles[size], className)}
      data-testid="mui-badge"
      id={id}
      style={{ ...style }}
      {...props}
    >
      <span>{String(text)}</span>
    </div>
  )
}

export default Badge
